// This is serve as a basis for the future implementation of when /auth/me is ready, so we can store the user's info here

import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@store/store';

interface AppState {
    title: string;
}

const initialState: AppState = {
    title: 'Victron Professional',
};

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setTitle: (state, action: PayloadAction<string>) => {
            state.title = action.payload ?? 'Victron Professional';
        },
    },
});

const selectTitle = (state: RootState) => state.app.title;

export const { setTitle } = appSlice.actions;
export { selectTitle };

export default appSlice.reducer;
